module.exports = __webpack_public_path__ + "img/microsoft.1ac2354a.svg";